import { toast, ToastOptions, Id } from 'react-toastify';
import { NotifyType } from '../../types/enums/notifytype';

export const notify = () => {
    const config: ToastOptions = {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
    };

    let toastQueue: Id[] = [];

    const message = (type: NotifyType, message: string) => {
        if (toastQueue.length >= 5) {
            // Remove the oldest toast from the queue
            const oldestToast = toastQueue.shift();
            if (oldestToast) toast.dismiss(oldestToast);
        }

        // Show the new toast and add it to the queue
        const toastId = (() => {
            switch (type) {
                case NotifyType.Success:
                    return toast.success(message, config);
                case NotifyType.Error:
                    return toast.error(message, config);
                case NotifyType.Info:
                    return toast.info(message, config);
                case NotifyType.Warning:
                    return toast.warn(message, config);
                default:
                    return toast(message, config);
            }
        })();

        toastQueue.push(toastId);
    };

    return {
        message
    };
};
